import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import copy from 'clipboard-copy';
import { Link } from '@mui/docs/Link';
import { Portal } from '@mui/base/Portal';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Slide from '@mui/material/Slide';
import TextFieldsRoundedIcon from '@mui/icons-material/TextFieldsRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import SvgMuiLogomark, { muiSvgLogoString, muiSvgWordmarkString } from 'docs/src/icons/SvgMuiLogomark';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LogoWithCopyMenu(_ref) {
  var _ref$logo = _ref.logo,
    LogoSvg = _ref$logo === void 0 ? SvgMuiLogomark : _ref$logo,
    _ref$logoSvgString = _ref.logoSvgString,
    logoSvgString = _ref$logoSvgString === void 0 ? muiSvgLogoString : _ref$logoSvgString,
    _ref$wordmarkSvgStrin = _ref.wordmarkSvgString,
    wordmarkSvgString = _ref$wordmarkSvgStrin === void 0 ? muiSvgWordmarkString : _ref$wordmarkSvgStrin,
    marginLeft = _ref.marginLeft;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    contextMenu = _React$useState2[0],
    setContextMenu = _React$useState2[1];
  var handleContextMenu = function handleContextMenu(event) {
    event.preventDefault();
    setContextMenu(contextMenu === null ? {
      mouseX: event.clientX + 8,
      mouseY: event.clientY - 8
    } : null);
  };
  var handleClose = function handleClose() {
    setContextMenu(null);
  };
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    copied = _React$useState4[0],
    setCopied = _React$useState4[1];
  var handleCopy = function handleCopy(svgSnippet) {
    setCopied(true);
    copy(svgSnippet).then(function () {
      setTimeout(function () {
        return setCopied(false);
      }, 3500);
      handleClose();
    });
  };
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      component: Link,
      href: "/",
      "aria-label": "Go to homepage",
      onContextMenu: handleContextMenu,
      sx: {
        mr: 1,
        ml: marginLeft ? 1.5 : undefined,
        '& > svg': {
          m: '0 !important'
        } // override the 2px margin-left coming from the Link component
      },
      children: /*#__PURE__*/_jsx(LogoSvg, {
        height: 28,
        width: 28
      })
    }), /*#__PURE__*/_jsxs(Menu, {
      open: contextMenu !== null,
      onClose: handleClose,
      anchorReference: "anchorPosition",
      anchorPosition: contextMenu !== null ? {
        top: contextMenu.mouseY,
        left: contextMenu.mouseX
      } : undefined,
      sx: function sx(theme) {
        return {
          '& .MuiMenuItem-root': {
            gap: 1,
            '& path': {
              fill: (theme.vars || theme).palette.text.tertiary,
              color: (theme.vars || theme).palette.text.tertiary
            },
            '&:hover, &:focus-visible': {
              '& path': {
                fill: (theme.vars || theme).palette.text.primary,
                color: (theme.vars || theme).palette.text.primary
              }
            }
          }
        };
      },
      children: [/*#__PURE__*/_jsxs(MenuItem, {
        onClick: function onClick() {
          return handleCopy(logoSvgString);
        },
        children: [/*#__PURE__*/_jsx(LogoSvg, {
          height: 16,
          width: 18
        }), "Copy logo as SVG"]
      }), /*#__PURE__*/_jsxs(MenuItem, {
        onClick: function onClick() {
          return handleCopy(wordmarkSvgString);
        },
        children: [/*#__PURE__*/_jsx(TextFieldsRoundedIcon, {
          sx: {
            fontSize: '18px'
          }
        }), "Copy wordmark as SVG"]
      })]
    }), /*#__PURE__*/_jsx(Portal, {
      container: function container() {
        return document.body;
      },
      children: /*#__PURE__*/_jsx(Snackbar, {
        open: copied,
        onClose: handleClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right'
        },
        TransitionComponent: Slide,
        message: /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          },
          children: [/*#__PURE__*/_jsx(CheckCircleRoundedIcon, {
            sx: {
              fontSize: '18px',
              color: 'success.main'
            }
          }), "Logo SVG copied to clipboard!"]
        })
      })
    })]
  });
}